module.exports = __webpack_public_path__ + "static/media/transformation-arrow.dd4e0164.svg";